import { isEqual } from 'lodash-es'
import type { PlanTableDTO } from '@mutations'

/**
 * Whether the Planansicht's storey-resolved tables (`resolved`) are outdated by a mutation
 * response (`dtos`). Resolved content only depends on the template and its options, so only an
 * added template table or a changed template/option needs a re-resolve — not a move, rename,
 * plan config change or delete.
 */
export const needsPlanViewReresolve = (
  resolved: PlanTableDTO[] | undefined,
  dtos: PlanTableDTO[],
): boolean => {
  const resolvedById = new Map(resolved?.map(dto => [dto.id, dto]))
  return dtos.some(dto => {
    if (dto.tableType !== 'TemplatePlanTable') return false
    const previous = resolvedById.get(dto.id)
    return (
      !previous ||
      previous.templateKey !== dto.templateKey ||
      !isEqual(previous.templateOptions, dto.templateOptions)
    )
  })
}
